"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const VisionParagraph_1 = require("../FooterValues/VisionParagraph");
const VisionIcon_1 = require("../FooterValues/VisionIcon");
const FooterValues_1 = require("../FooterValues/FooterValues");
function Footer(_a) {
    var { className, topFooterComponents, bottomFooterComponents } = _a, props = __rest(_a, ["className", "topFooterComponents", "bottomFooterComponents"]);
    return (react_1.default.createElement("footer", Object.assign({ id: "footer", className: (0, classnames_1.default)('bg-gray w-full', className) }, props),
        topFooterComponents,
        react_1.default.createElement("div", { className: "p-4 max-w-screen-2xl mx-auto" },
            react_1.default.createElement("div", { className: "py-8 px-4 border-t-1 border-b-1 border-gray-light grid grid-cols-1 md:grid-cols-3" },
                react_1.default.createElement(VisionParagraph_1.VisionParagraph, { title: "we're here for you", text: "Your family. Your Bible study. Your community. You are the church, and Lifeway is here to serve you with biblical resources for everything life brings your way." }),
                react_1.default.createElement(VisionIcon_1.VisionIcon, null),
                react_1.default.createElement(VisionParagraph_1.VisionParagraph, { title: "we're here for the church", text: "Behind every support specialist, Bible study editor, graphic designer, and accountant is a Sunday School teacher, kids volunteer, or small group leader. And we\u2019re all in it for the same reason\u2014to fuel the church\u2019s mission of making disciples." }))),
        react_1.default.createElement("div", { className: "pt-0 px-4 pb-8 max-w-screen-2xl mx-auto" },
            react_1.default.createElement(FooterValues_1.FooterValues, null)),
        bottomFooterComponents));
}
exports.Footer = Footer;
